<template>
  <div class="toggle-switch-container" :data-testid="testId">
    <div
      class="custom-toggle"
      :class="{ 'toggle-on': modelValue }"
      @click="toggle"
      role="switch"
      :aria-checked="modelValue"
      tabindex="0"
      @keydown.space.prevent="toggle"
    >
      <div class="toggle-circle"></div>
    </div>
    <label class="toggle-label" @click="toggle">{{ modelValue ? labelOn : labelOff }}</label>
  </div>
</template>

<script>
export default {
  name: 'ToggleSwitch',
  props: {
    modelValue: {
      type: Boolean,
      required: true,
    },
    labelOn: {
      type: String,
      required: true,
    },
    labelOff: {
      type: String,
      required: true,
    },
    testId: {
      type: String,
      default: '',
    },
  },
  emits: ['update:modelValue'],
  methods: {
    toggle() {
      this.$emit('update:modelValue', !this.modelValue);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/StrVariables.scss"
@import "@/assets/styles/ToggleSwitch.scss"

</style>